import { MiddlewareAction } from "../middleware";
import { ContractorActions, ContractorAddEditForm } from "../models";

export enum SearchOn {
  MOBILE = "MOBILE",
  EMPLOYERS_CONTRACTOR_ID = "EMPLOYERS_CONTRACTOR_ID",
}

export enum ContractorAction {
  REQUEST_GET_CONTRACTORS = "REQUEST_GET_CONTRACTORS",
  REQUEST_GET_CONTRACTOR_DETAILS = "REQUEST_GET_CONTRACTOR_DETAILS",
  REQUEST_GET_CONTRACTOR_USER_DETAILS = "REQUEST_GET_CONTRACTOR_USER_DETAILS",
  REQUEST_BLOCK_UNBLOCK_CONTRACTOR = "REQUEST_BLOCK_UNBLOCK_CONTRACTOR",
  REQUEST_ADD_CONTRACTOR = "REQUEST_ADD_CONTRACTOR",
  REQUEST_UPDATE_CONTRACTOR = "REQUEST_UPDATE_CONTRACTOR",
}

export function getContractors(context: {
  pageNo: number;
  searchOn?: SearchOn;
  limit?: number;
  searchValue?: string;
  isBlocked?: boolean;
}): MiddlewareAction {
  const { pageNo = 1, isBlocked, limit = 10, searchOn, searchValue } = context;

  return {
    actionName: ContractorAction.REQUEST_GET_CONTRACTORS,
    type: "GET",
    url: "/employer-admin/contractor/search",
    params: {
      pageNumber: pageNo,
      isBlocked,
      limit,
      searchOn,
      searchValue,
    },
  };
}

export function getContractorDetails(contractorId: string): MiddlewareAction {
  return {
    actionName: ContractorAction.REQUEST_GET_CONTRACTOR_DETAILS,
    type: "GET",
    url: `/employer-admin/contractor/${contractorId}`,
  };
}

export function getContractorUserDetails(
  contractorId: string
): MiddlewareAction {
  return {
    actionName: ContractorAction.REQUEST_GET_CONTRACTOR_USER_DETAILS,
    type: "GET",
    url: `/employer-admin/contractor/${contractorId}/user-details`,
  };
}

export function bulkBlockUnblockContractor(
  contractorIds: Array<string>,
  action: ContractorActions
): MiddlewareAction {
  return {
    actionName: ContractorAction.REQUEST_BLOCK_UNBLOCK_CONTRACTOR,
    type: "POST",
    url: `/employer-admin/contractor/bulk-actions`,
    body: {
      contractorIds,
      action,
    },
  };
}

export function addContractor(body: ContractorAddEditForm): MiddlewareAction {
  return {
    actionName: ContractorAction.REQUEST_ADD_CONTRACTOR,
    type: "POST",
    url: "/employer-admin/contractor",
    body,
  };
}

export function updateContractor(
  isTransactionAllowed: boolean,
  contractorId: string
): MiddlewareAction {
  return {
    actionName: ContractorAction.REQUEST_UPDATE_CONTRACTOR,
    type: "PATCH",
    url: `/employer-admin/contractor/${contractorId}`,
    body: {
      isTransactionAllowed,
    },
  };
}
